import { useMutation } from '@tanstack/react-query';

const useExtendedMutation = (mutationFn, onSuccess, onError) => {
  const mutation = useMutation({
    mutationFn: (input) => mutationFn(input, onSuccess),
    onSuccess,
    onError,
  });

  const mutateOnVirtualThread = async (input) => {
    try {
      return await mutation.mutateAsync(input);
    } catch (err) {
      console.log(err);
      //throw err;
    }
  }

  return {
    ...mutation,
    mutateOnVirtualThread,
  };
}

export { useExtendedMutation }